import { css } from "styled-components";
import { COLORS } from "../../utils/colors";

/**
 * Shared pagination look for every table/list in the app. Import and spread
 * these into the relevant styled-component so gaps, rounding, alignment and the
 * active-page colour stay identical everywhere.
 */

/* For the `.ant-pagination` rendered *inside* an antd Table or List. */
export const tablePaginationCss = css`
  && .ant-pagination {
    margin-top: 14px;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 8px;
  }

  && .ant-pagination .ant-pagination-item,
  && .ant-pagination .ant-pagination-prev,
  && .ant-pagination .ant-pagination-next {
    margin: 0;
    border-radius: 8px;
  }

  && .ant-pagination .ant-pagination-item-active {
    background: ${COLORS.entriesbg};
    border-color: ${COLORS.entriesbg};
    border-radius: 8px;
  }

  && .ant-pagination .ant-pagination-item-active a {
    color: ${COLORS.primary};
  }
`;

/* For a standalone <Pagination> component (e.g. the mobile card lists). */
export const standalonePaginationCss = css`
  && {
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 8px;
  }

  && .ant-pagination-item,
  && .ant-pagination-prev,
  && .ant-pagination-next {
    margin: 0;
    border-radius: 8px;
  }

  && .ant-pagination-item-active {
    background: ${COLORS.entriesbg};
    border-color: ${COLORS.entriesbg};
    border-radius: 8px;
  }

  && .ant-pagination-item-active a {
    color: ${COLORS.primary};
  }
`;
